var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStripe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 14,
    viewBox: "0 0 34 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_191_7748)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.7999 8.09901C33.7999 5.70967 32.6426 3.82434 30.4306 3.82434C28.2092 3.82434 26.8652 5.70967 26.8652 8.08034C26.8652 10.8897 28.4519 12.3083 30.7292 12.3083C31.8399 12.3083 32.6799 12.0563 33.3146 11.7017V9.83501C32.6799 10.1523 31.9519 10.3483 31.0279 10.3483C30.1226 10.3483 29.3199 10.031 29.2172 8.92967H33.7812C33.7812 8.80834 33.7999 8.32301 33.7999 8.09901ZM29.1892 7.21234C29.1892 6.15767 29.8332 5.71901 30.4212 5.71901C30.9906 5.71901 31.5972 6.15767 31.5972 7.21234H29.1892Z",
    fill: "white",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.2625 3.82434C22.3479 3.82434 21.7599 4.25367 21.4332 4.55234L21.3119 3.97367H19.2585V14.8563L21.5919 14.3617L21.6012 11.7203C21.9372 11.963 22.4319 12.3083 23.2532 12.3083C24.9239 12.3083 26.4452 10.9643 26.4452 8.00567C26.4359 5.29901 24.8959 3.82434 23.2625 3.82434ZM22.7025 10.255C22.1519 10.255 21.8252 10.059 21.6012 9.81634L21.5919 6.35367C21.8345 6.08301 22.1705 5.89634 22.7025 5.89634C23.5519 5.89634 24.1399 6.84834 24.1399 8.07101C24.1399 9.32167 23.5612 10.255 22.7025 10.255Z",
    fill: "white",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0479 3.27367L18.3905 2.76967V0.875L16.0479 1.36967V3.27367Z",
    fill: "white",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3905 3.983H16.0479V12.1497H18.3905V3.983Z",
    fill: "white",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5374 4.67366L13.3881 3.983H11.3721V12.1497H13.7054V6.615C14.2561 5.89633 15.1894 6.027 15.4787 6.12966V3.983C15.1801 3.871 14.0881 3.66566 13.5374 4.67366Z",
    fill: "white",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.87065 1.95767L6.59332 2.44301L6.58398 9.91901C6.58398 11.3003 7.61998 12.3177 9.00132 12.3177C9.76665 12.3177 10.3267 12.1777 10.6347 12.0097V10.115C10.336 10.2363 8.86132 10.6657 8.86132 9.28434V5.97101H10.6347V3.98301H8.86132L8.87065 1.95767Z",
    fill: "white",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.56128 6.35367C2.56128 5.98967 2.85995 5.84967 3.35462 5.84967C4.06395 5.84967 4.95995 6.06434 5.66928 6.44701V4.25367C4.89462 3.94567 4.12928 3.82434 3.35462 3.82434C1.45995 3.82434 0.199951 4.81367 0.199951 6.46567C0.199951 9.04168 3.74662 8.63101 3.74662 9.74167C3.74662 10.171 3.37328 10.311 2.85062 10.311C2.07595 10.311 1.08662 9.99368 0.302618 9.56434V11.7857C1.17062 12.159 2.04795 12.3177 2.85062 12.3177C4.79195 12.3177 6.12662 11.3563 6.12662 9.68567C6.11728 6.90434 2.56128 7.39901 2.56128 6.35367Z",
    fill: "white",
    fillOpacity: 0.9
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_191_7748"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33.6,
    height: 14,
    fill: "white",
    transform: "translate(0.199951)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStripe);
export default __webpack_public_path__ + "static/media/stripe.686b18efeb16e7c4e3228cc60b8409d3.svg";
export { ForwardRef as ReactComponent };